/* Package JSON Import will be here */
import React from 'react';
import { Button, Checkbox, Form, Modal, Input } from 'semantic-ui-react';
import '../../crud/curd.css';

const UpdateComponent = props => {
  return (
    <Modal closeIcon
      open={true}
      closeOnDimmerClick={false}
      size='tiny'
      onClose={() => props.onClose()}
    >
      <Modal.Header className="headerColor text-color">Update User</Modal.Header>
      <Modal.Content scrolling style={{ minHeight: "auto" }}>
        <Form className="update-form">
          <Form.Field>
            <Input label='First Name' name="firstName" placeholder='First Name' vvalue={props.firstName} onChange={(e) => props.onChange(e)} />
          </Form.Field>
          <Form.Field>
            <Input label='Last Name' name="lastName" placeholder='Last Name' value={props.lastName} onChange={(e) => props.onChange(e)} />
          </Form.Field>

          <Form.Field>
            <Checkbox label='I agree to the Terms and Conditions'
              name="checkbox"
              checked={props.checkbox}
              onClick={(e, data) => props.onChangeCheckbox(e, data)} />
          </Form.Field>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button primary onClick={() => props.onUpdate()}>
          Update
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

UpdateComponent.displayName = "UpdateComponent";

export default UpdateComponent;